import React from 'react';

import LoadingPlaceholder from './LoadingPlaceholder.component';

const SingleLoadingPlaceholder = () => (
  <LoadingPlaceholder count={1} />
);

export default SingleLoadingPlaceholder;
